import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  item: null,
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createCustomCategory({ commit }, item) {
    return this.$axios.$post('admin/customCategories/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removeCustomCategory({ commit }, item) {
    return this.$axios.$delete(`admin/customCategories/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateCustomCategory({ commit }, item) {
    return this.$axios.$put(`admin/customCategories/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
      return response.data
    })
  },
  fetchCustomCategory({ commit }, id) {
    return this.$axios.$get(`admin/customCategories/${id}`).then((response) => {
      return response.data
    })
  },
  fetchCustomCategories({ commit }) {
    return this.$axios.$get('admin/customCategories').then((response) => {
      commit('load', response.data)
      return response.data
    })
  },
}
